import { graphql } from 'gatsby'
import { RichText } from 'prismic-reactjs'
import React from 'react'

import htmlSerializer, { linkResolver } from '@somo/oxd-apps-www/src/utils/html-serializer'
import PrismicPage from '@cinch/oxd-pages/cms-page/src'

import SEO from '../components/seo'

interface PageProps {
  data: { prismic: { allPages: { edges: any[] } } }
}

const Page: React.FC<PageProps> = ({ data }) => {
  const { prismic } = data
  const doc = prismic.allPages.edges.slice(0, 1).pop()

  if (!doc || !doc.node) {
    return null
  }

  const hasTitle = doc.node.title && !!doc.node.title.length
  const title = hasTitle ? doc.node.title[0].text : ''

  return (
    <>
      <SEO title={title} />
      <PrismicPage title={title} content={RichText.render(doc.node.content || [], linkResolver, htmlSerializer)} />
    </>
  )
}

export const query = graphql`
  query PageQuery($uid: String) {
    prismic {
      allPages(uid: $uid) {
        edges {
          node {
            title
            content
          }
        }
      }
    }
  }
`

export default Page
